import { IsoFooterCardProps } from "@/src/components/cards/isofooter/v3";
import { SectionHeadingWithoutStylingProps } from "@/src/components/section-heading/interface";
import { IsoFooterCardsCaraousl } from "./cards-carousel";
import { IsoFooterSectionData_en } from "@/data/en/isofooter-section/v4";
import { IsoFooterSectionData_ar } from "@/data/ar/isofooter-section/v4";
export interface IsoFooterSectionProps {
   sectionHeading: SectionHeadingWithoutStylingProps;
   cards: IsoFooterCardProps[];
   params:{
      lang: string
   }
}

export function IsoFooterSection({params}: IsoFooterSectionProps) {
   const IsoFooterSectionData = params.lang === "en" ? IsoFooterSectionData_en : IsoFooterSectionData_ar
   const { sectionHeading, cards } = IsoFooterSectionData;
   return (
      <section className="p-5   w-full  overflow-hidden border-10 [mask-image:_linear-gradient(to_right,transparent_0,_black_200px,_black_calc(100%-300px),transparent_100%)]">
         <IsoFooterCardsCaraousl cards={cards} />
      </section>
   );
}